import api from "@/api";
export default {
    namespaced: true,
    state: {
        relateProductList: [],
        userProductList: [],
    },
    mutations: {
        setRelateProductList(state, list) {
            state.relateProductList = list;
        },
        setUserProductList(state, userProductList) {
            state.userProductList = userProductList;
        },
        setSubmitRet(state, submitRet) {
            state.submitRet = submitRet;
        },
        setDeleteRet(state, deleteRet) {
            state.deleteRet = deleteRet;
        },

    },
    actions: {
        async loadUserProductList({ commit }, userId) {
            let userProductList = await api.setting.loadUserProductList(userId);
            if (userProductList) {
                commit('setUserProductList', userProductList.list);
            }
        },
        async loadRelateProductList({ commit }, workspaceId) {
            let productData = await api.setting.loadRelateProductList(workspaceId);
            if (productData) {
                commit('setRelateProductList', productData);
            }else{
                commit('setRelateProductList', []);
            }
        },
        async deleteRelateProduct({ commit }, relationIdData) {
            commit
            await api.setting.deleteRelateProduct(relationIdData);
        }

    }
}